import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../api/auth";

export default function ProtectedRoute({ children }) {
  const token = getToken();
  const location = useLocation();

  // Not logged in → send to login
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

 
  return children;
}
